import {Action} from "@ngrx/store";
import {IAccountOperation} from "../../models/accounting/accounting.interface";

export enum EAccountOperationActions {
  GetAccountOperations = '[Account Operations] Get Account Transactions',
  GetAccountOperationsSuccess = '[Account Operations] Get Account Transactions Success',
  GetAccountOperationsFailure = '[Account Operations] Get Account Transactions Failure',

  ClearAccountOperations = '[Account Operations] Get Account Transactions'

}

export class GetAccountOperations implements Action {
  public readonly type = EAccountOperationActions.GetAccountOperations;
  constructor(public payload: string){}
}
export class GetAccountOperationsSuccess implements Action {
  public readonly type = EAccountOperationActions.GetAccountOperationsSuccess;
  constructor(public payload: Array<IAccountOperation>){}
}
export class GetAccountOperationsFailure implements Action {
  public readonly type = EAccountOperationActions.GetAccountOperationsFailure;
}
export class ClearAccountOperations implements Action {
  public readonly type = EAccountOperationActions.ClearAccountOperations;
}

export type AccountOperationsActions =

  GetAccountOperations |
  GetAccountOperationsSuccess |
  GetAccountOperationsFailure |
  ClearAccountOperations;
